import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  ErrorBlock,
  I18n,
} from 'components';

import NotificationPoint from '../NotificationPoint';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const NotificationPoints = ({
  title,
  notificationPoints,
  toggleNotificationPoint,
  togglePointEditingState,
  saveNotificationPoint,
  confirmNotificationPointCode,
  resetNotificationPointCodeValidation,
  sendNotificationPointCode,
  isRecoveryPassword,
  toggleConfirmationCodePopup,
  error,
  refreshAction,
  isConfirmationOpened,
  isPointEditing,
  accountConvergent,
}) => {
  if (error) {
    return (
      <ErrorBlock
        title={<I18n path="settings.notifications.title" />}
        refreshAction={refreshAction}
      />
    );
  }

  return (
    <DataBlocks.Block
      title={title}
      isLoading={!notificationPoints}
    >
      <DataBlocks.Table>
        {accountConvergent && (
          <DataBlocks.TableRow>
            <DataBlocks.TableCell className={cx('account')}>
              <I18n path="common.account" />
            </DataBlocks.TableCell>
            <DataBlocks.TableCell />
            <DataBlocks.TableCell>
              {accountConvergent}
            </DataBlocks.TableCell>
            <DataBlocks.TableCell />
            <DataBlocks.TableCell />
          </DataBlocks.TableRow>
        )}
        {notificationPoints && notificationPoints.map((point) => (
          <NotificationPoint
            {...point}
            isConfirmationOpened={isConfirmationOpened && point.isConfirmationOpened}
            isEditing={isPointEditing && point.isEditing}
            key={`${point.type}-${point.value}`}
            togglePoint={toggleNotificationPoint}
            toggleEditingState={togglePointEditingState}
            saveNotificationPoint={saveNotificationPoint}
            confirmNotificationPointCode={confirmNotificationPointCode}
            resetPointCodeValidation={resetNotificationPointCodeValidation}
            resendCode={sendNotificationPointCode}
            isRecoveryPassword={isRecoveryPassword}
            toggleConfirmationCodePopup={toggleConfirmationCodePopup}
          />
        ))}
      </DataBlocks.Table>
    </DataBlocks.Block>
  );
};

NotificationPoints.propTypes = {
  error: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  notificationPoints: PropTypes.array,
  toggleNotificationPoint: PropTypes.func,
  togglePointEditingState: PropTypes.func,
  saveNotificationPoint: PropTypes.func,
  confirmNotificationPointCode: PropTypes.func,
  resetNotificationPointCodeValidation: PropTypes.func,
  sendNotificationPointCode: PropTypes.func,
  toggleConfirmationCodePopup: PropTypes.func,
  refreshAction: PropTypes.func,
  isRecoveryPassword: PropTypes.bool,
  isConfirmationOpened: PropTypes.bool,
  isPointEditing: PropTypes.bool,
  accountConvergent: PropTypes.string,
};

export default NotificationPoints;
